var _a, _b, _c, _d, _e;
import * as $ from "jquery";
import "bootstrap";
import retinajs from 'retinajs';
import { init, showReportDialog, browserTracingIntegration, browserProfilingIntegration, replayIntegration } from "@sentry/vue";
import Vue from 'vue';
window.jQuery = $;
window.$ = $;
window.addEventListener('load', retinajs);
if (((_a = window.s.sentry) === null || _a === void 0 ? void 0 : _a.enabled) && window.s.sentry.sentry_vue_dsn) {
    init({
        Vue,
        dsn: window.s.sentry.sentry_vue_dsn,
        release: window.s.sentry.release,
        environment: window.s.sentry.environment,
        beforeSend(event) {
            if (event.exception && event.event_id) {
                showReportDialog({ eventId: event.event_id });
            }
            return event;
        },
        integrations: [
            // Add browser profiling integration to the list of integrations
            browserTracingIntegration(),
            browserProfilingIntegration(),
            replayIntegration(),
            // Sentry.feedbackIntegration({
            //   colorScheme: "system",
            // }),
        ],
        tracesSampleRate: (_b = window.s.sentry.tracesSampleRate) !== null && _b !== void 0 ? _b : 0.1,
        // tracePropagationTargets: ["staging", "http://apple.staging.venngo.com/"],
        profilesSampleRate: (_c = window.s.sentry.profilesSampleRate) !== null && _c !== void 0 ? _c : 0.1,
        replaysSessionSampleRate: (_d = window.s.sentry.replaysSessionSampleRate) !== null && _d !== void 0 ? _d : 0.1,
        replaysOnErrorSampleRate: (_e = window.s.sentry.replaysOnErrorSampleRate) !== null && _e !== void 0 ? _e : 0.1,
        attachStacktrace: true,
    });
}
